import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ROUTES } from '../constants/routes';

function ProtectedRoute({ children }) {
  const { user, token } = useContext(AuthContext);
  const location = useLocation();
  if (!user || !token) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  if (user.must_change_password && location.pathname !== ROUTES.CHANGE_PASSWORD) {
    return <Navigate to={ROUTES.CHANGE_PASSWORD} replace />;
  }
  return children;
}

export default ProtectedRoute; 